import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Search from '../../assets/images/searchIcon.png';
import Report from '../../assets/images/report-img.png';
import defaultIcon from '../../assets/images/defaultImg.png';
import '../customTable/CustomTable.scss';
import EyeIcon from '../../assets/images/EyeIcon.png';
import AddIcon from '../../assets/images/AddIcon.png';
import DeleteIcon from '../../assets/images/DeleteIcon.png';
import EditIcon from '../../assets/images/EditIcon.png';
import Switch from 'react-switch';

function CustomTable({ showTitle, onEyeClick, switchOnclick, onToggleClick, titlehead, sliderHeaderText, data, headers, showStatusColumn, showActions, actionsHeaderText, showSearchBar, showTableImg, ImgHeaderText, showActions2, actionsHeaderText2, onEditClick, onDeleteClick, expandedRow, showSearchBarButtons, showEdit, showBankIcon, showDeleteIcon, showIcon, showtablecss, showPagination, searchBarPlaceholder, showAddButton, showEyeIcon, showSlider, onSearchChange, showSlider2, showSlider3
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const itemsPerPage = 10;
    const navigate = useNavigate();

    const handleNextPage = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const currentData = data?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(data?.length / itemsPerPage);

    // const handleCellClick = (value) => {
    //     if (value === 'Active') {
    //         navigate('/activepayments');
    //     } else if (value === 'Inactive') {
    //         navigate('/activepayments');
    //     }
    // };

    const [checked, setChecked] = useState(false);

    const handleChange = (nextChecked) => {
        setChecked(nextChecked);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        onSearchChange(e.target.value);
    };

    const handleSwitchChange = (checked, userId) => {
        onToggleClick(userId, checked);
    };

    return (
        <>
            <div className={`${showtablecss ? 'custom-table-css' : 'another-table-css'} `}>
                {showTitle &&
                    <div className="d-flex align-items-center justify-content-between mb-0">
                        <p className="title-heading">{titlehead}</p>
                        {showAddButton && <button className="category-btn">
                            Add Sub Category
                            <img src={AddIcon} style={{ width: '24px', objectFit: 'contain', marginLeft: 10 }} />
                        </button>}
                    </div>

                }
                {showSearchBar &&
                    <div className='searchBar mb-4 mt-4'>
                        <div className={window.innerWidth < 900 ? 'col-md-12 my-2' : 'col-xl-12 d-flex justify-content-between align-items-center searchbar p-0'}>
                            <div className='d-flex align-items-center ms-3'>
                                <img src={Search} style={{ width: 18, objectFit: 'contain', marginRight: 16 }} />
                                <input
                                    type='text'
                                    placeholder={searchBarPlaceholder || 'Search by ID Name, Email, etc'}
                                    className='searchbox'
                                    style={{ width: 700 }}
                                    value={searchText}
                                    onChange={handleSearchChange}
                                />
                            </div>
                            {showSearchBarButtons &&
                                <div className={window.innerWidth < 900 ? 'my-1' : 'd-flex align-items-center'}>
                                    <button className='whiteBtn me-1'>Report
                                        <img src={Report} style={{ width: 9, objectFit: 'contain', marginLeft: 8 }} />
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                }
                <div style={{ overflowX: 'auto', padding: '0 0', width: window.innerWidth < 900 ? window.innerWidth - 70 : '' }}>
                    <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '2px 16px' }} className={window.innerWidth < 900 ? 'mt-4' : 'custom-table'} cellSpacing="6" cellPadding="10">
                        <thead>
                            <tr className='table-head'>
                                {headers?.map((header, index) => {
                                    if (header === 'donotshowID') {
                                        return null;
                                    }
                                    return <th className='table-header' key={index}>{header}</th>;
                                })}
                                {showStatusColumn && <th>Status</th>}
                                {showActions &&
                                    <th className='table-header'>{actionsHeaderText || ''} </th>
                                }
                                {showActions2 &&
                                    <th className='table-header'>{actionsHeaderText2 || ''} </th>
                                }
                                {showTableImg && <th className='table-header'>{ImgHeaderText || ''}</th>}
                                {showSlider && <th className='table-header'>{sliderHeaderText || ''}</th>}
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            {currentData?.length === 0 ? (
                                <tr>
                                    <td style={{ height: '30vh' }} colSpan={headers?.length + (showActions ? 1 : 0) + (showStatusColumn ? 1 : 0)} className='text-center'>
                                        No data found
                                    </td>
                                </tr>
                            ) : (
                                currentData?.map((rowData, rowIndex) => (
                                    <tr key={rowIndex} className='table-body-tr' style={{ position: 'relative' }}>
                                        {Object.entries(rowData)?.map(([key, value], colIndex) => {
                                            if (headers[colIndex] === 'donotshowID') {
                                                return null;
                                            }
                                            const classNames = {
                                                'Active': 'table-green-class',
                                                'Inactive': 'table-red-class',
                                                'Successful': 'table-green-class',
                                                'Pending': 'table-yellow-class',
                                                'Success': 'table-green-class',
                                                'Reject': 'table-red-class'
                                            };

                                            let className = '';

                                            if (headers[colIndex] === 'Subscription'
                                                || headers[colIndex] === 'Full Name'
                                                || headers[colIndex] === 'Gender') {
                                                className = 'table-Black-Text-class';  // Replace 'custom-name-class' with your desired class name
                                            }

                                            if (headers[colIndex] === 'Premium Subscription'
                                                || headers[colIndex] === 'Status'
                                                || headers[colIndex] === 'User Status') {
                                                className = classNames[value];
                                            }

                                            if (headers[colIndex] === 'Returns') {
                                                className = 'green-text';
                                            }

                                            if (key === 'mastercategory') {
                                                return (
                                                    <td className='table-row' key={colIndex}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {showIcon &&
                                                                <img
                                                                    src={value.icon || defaultIcon}
                                                                    alt='SubCategory Icon'
                                                                    style={{ width: 60, marginRight: 8, border: 'solid 2px #EDEDED', padding: 2, borderRadius: 8, objectFit: 'contain' }}
                                                                />
                                                            }
                                                            {showBankIcon && <img src={value.icon1} alt='SubCategory Icon' style={{ width: 32, marginRight: 8 }} />}
                                                            <div>
                                                                <div className='table-big-text'>{value.text}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            return (
                                                <td className='table-row' key={colIndex}>
                                                    <div className={className} style={{
                                                        display: expandedRow === rowIndex ? 'flex' : '',
                                                        alignItems: expandedRow === rowIndex ? 'start' : '',
                                                        height: window.innerWidth < 900 ? (expandedRow === rowIndex ? 250 : '') : (expandedRow === rowIndex ? 180 : '')
                                                    }}>
                                                        {value}
                                                    </div>
                                                </td>
                                            );
                                        })}
                                        {showActions && <td style={{ display: expandedRow === rowIndex ? 'flex' : '', alignItems: expandedRow === rowIndex ? 'start' : '', }}>
                                            <div className='d-flex align-items-center'>
                                                {showEdit &&
                                                    <button className="button-icons" onClick={() => onEditClick(rowData)}>
                                                        <img
                                                            src={EditIcon}
                                                            style={{ width: 24, objectFit: 'contain', marginLeft: 20 }}
                                                        />
                                                    </button>
                                                }
                                                {showDeleteIcon &&
                                                    <button className="button-icons" onClick={() => onDeleteClick(rowData)}>
                                                        <img
                                                            src={DeleteIcon}
                                                            style={{ width: 24, objectFit: 'contain', marginLeft: 10 }}
                                                        />
                                                    </button>
                                                }
                                                {/* {showDeleteIcon &&
                                                <img src={DeleteIcon} style={{ width: 24, objectFit: 'contain', marginLeft: 20 }} />
                                            } */}
                                                {showEyeIcon &&
                                                    <button className="button-icons me-2" onClick={() => onEyeClick(rowData)}>
                                                        <img src={EyeIcon} style={{ width: 20, objectFit: 'contain', marginLeft: 15 }} />
                                                    </button>
                                                }
                                                {showSlider &&
                                                    <div className="form-check form-switch" >
                                                        <input className="form-check-input" onClick={() => onToggleClick(rowData)} type="checkbox" role="switch" checked={rowData.userStatus == 'Active' ? true : false} />
                                                    </div>
                                                }
                                                {showSlider2 &&
                                                    <div className="form-check form-switch" >
                                                        <input className="form-check-input" onClick={() => onToggleClick(rowData)} type="checkbox" role="switch" checked={rowData.is_active ? true : false} />
                                                    </div>
                                                }
                                                {showSlider3 &&
                                                    <div className="form-check form-switch ms-2" >
                                                        <input className="form-check-input" onClick={() => onToggleClick(rowData)} type="checkbox" role="switch" checked={rowData.status == 'Active' ? true : false} />
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                        }
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                {showPagination &&
                    <div className='pagination-controls d-flex justify-content-between align-items-center mt-3'>
                        <div className='page-info'>Page {currentPage} of <span className="page-info totalpage">{totalPages}</span></div>
                        <div>
                            <button className={`pagination-btn ${currentPage === 1 ? '' : 'nextbtn'}`} onClick={handlePreviousPage} disabled={currentPage === 1}>
                                Previous
                            </button>
                            <button className={`pagination-btn ${currentPage === totalPages ? '' : 'nextbtn'}`} onClick={handleNextPage} disabled={currentPage === totalPages}>
                                Next
                            </button>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default CustomTable;
